module.exports = __webpack_public_path__ + "static/media/29EUNOG17.8826fc02.jpg";